<template>
  <b-modal
    id="remove-leave-reason-modal"
    title="Remove Leave Reason"
    hide-footer
  >
    <h4 class="mb-2">
      Are you sure you want to remove this Leave Reason?
    </h4>
    <b-button
      variant="danger"
      block
      :disabled="deleting"
      @click="deleteHandler"
    >
      <b-spinner
        v-if="deleting"
        small
      />
      <span v-else>Yes, Delete</span>
    </b-button>
  </b-modal>
</template>

<script>
import { BModal, BButton, BSpinner } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BModal,
    BSpinner,
    BButton,
  },
  props: {
    reason: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const deleting = ref(false)
    const deleteHandler = async () => {
      try {
        deleting.value = true
        await axiosIns.delete(`/teams/leave-reasons/${props.reason.id}`)
        ctx.root.$bvModal.hide('remove-leave-reason-modal')
        ctx.emit('deleted')
      } finally {
        deleting.value = false
      }
    }
    return {
      deleteHandler,
      deleting,
    }
  },
}
</script>
